import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { updateMcpConfig } from '@polyai/stream/store/reducers/mcp-config/actions';
import type {
  MCPConfigSavedProfile,
  MCPConfigServer,
  MCPConfigState,
} from '@polyai/stream/store/reducers/mcp-config/types';

const serversAdapter = createEntityAdapter<MCPConfigServer, string>({
  selectId: server => server.id,
});
const profilesAdapter = createEntityAdapter<MCPConfigSavedProfile, string>({
  selectId: profile => profile.providerId,
});

const initialState: MCPConfigState = {
  servers: serversAdapter.getInitialState(),
  savedProfiles: profilesAdapter.getInitialState(),
};

const slice = createSlice({
  name: 'mcpConfig',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateMcpConfig, (state, action) => {
      serversAdapter.setAll(
        state.servers,
        Object.values(action.payload.serversById),
      );
      profilesAdapter.setAll(
        state.savedProfiles,
        Object.values(action.payload.savedProfilesByProvider),
      );
    });
  },
});

export { serversAdapter, profilesAdapter, updateMcpConfig };

export * from './types';
export default slice.reducer;
